// extracted by mini-css-extract-plugin
export default {"newPreview":"PreviewAdd_newPreview__ILs7h","button":"PreviewAdd_button__wwaaZ","text":"PreviewAdd_text__9R3yZ","right_icon":"PreviewAdd_right_icon__C95xF"};